// Display-only rounding helpers (backend does persistence rounding)

export const displayVolume = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) return value ?? '';
    return num.toFixed(3);
};

export const displayPrice = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) return value ?? '';
    return num.toFixed(2);
};

// Auto-rounding helpers for input fields
// Volume: allow up to 4 decimal places input, round to 3 decimals using standard rounding (>=0.0005 rounds up)
// Examples: 125.4567 → 125.457, 89.1234 → 89.123, 99.9999 → 100.000
export const roundVolumeInput = (value) => {
    if (value === '' || value === null || value === undefined) return value;
    const num = Number(value);
    if (Number.isNaN(num)) return value;
    // Round to 3 decimal places using standard rounding (>=0.0005 rounds up)
    // Math.round() implements standard rounding: >=0.5 rounds up, <0.5 rounds down
    const rounded = Math.round(num * 1000) / 1000;
    // Format with trailing zeros (e.g., 100 → 100.000)
    return rounded.toFixed(3);
};

// Price: allow up to 3 decimal places input, round to 2 decimals using standard rounding (>=0.005 rounds up)
// Examples: 505.456 → 505.46, 999.994 → 999.99
export const roundPriceInput = (value) => {
    if (value === '' || value === null || value === undefined) return value;
    const num = Number(value);
    if (Number.isNaN(num)) return value;
    // Round to 2 decimal places using standard rounding (>=0.005 rounds up)
    // Math.round() implements standard rounding: >=0.5 rounds up, <0.5 rounds down
    const rounded = Math.round(num * 100) / 100;
    // Format with trailing zeros (e.g., 100 → 100.00)
    return rounded.toFixed(2);
};

const formatNumericInput = (value) => {
    if (value === '' || value === null || value === undefined) return value;
    const num = Number(value);
    if (Number.isNaN(num)) return value;
    return num;
};

// Format volume for display in input (allow 4 decimals during input)
export const formatVolumeForInput = formatNumericInput;

// Format price for display in input (allow 3 decimals during input)
export const formatPriceForInput = formatNumericInput;


